import { useOptionalHouseholdChatContext } from '../contexts/householdChat.context';
import { useHasHouseholdChat } from './useHasHouseholdChat';

export function useHouseholdChatReplacement() {
  const householdChatContext = useOptionalHouseholdChatContext();
  const hasHouseholdChat = useHasHouseholdChat();

  return {
    householdChatContext,
    isHouseholdChatReplacementEnabled: Boolean(
      householdChatContext && hasHouseholdChat
    ),
  };
}
